import gql from 'graphql-tag';

export default gql`
    query completeMultipartUpload(
        $bucketKey: String!, 
        $parts: [PartsInput!]!, 
        $uploadId: String!, 
        $organisationId: String!, 
        $assetIdToTranscode: String
    ) {
        completeMultipartUpload(
            bucketKey: $bucketKey, 
            parts: $parts, 
            uploadId: $uploadId, 
            organisationId: $organisationId,
            assetIdToTranscode: $assetIdToTranscode
        )
    }
`;